import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { List, X } from '@phosphor-icons/react';
import { NAV_LINKS } from './navbar/navConfig';
import { NavbarAuthDesktop, NavbarAuthMobile } from './navbar/NavbarAuth';
import { LOGO_URL } from '../lib/brand';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const closeMobile = () => setMobileOpen(false);

  const handleLogout = async () => {
    await logout();
    closeMobile();
    navigate('/login');
  };

  const linkClass = (to) => {
    const active = location.pathname === to;
    return `text-sm font-medium transition-colors ${active ? 'text-[#F97316]' : 'text-gray-700 hover:text-[#F97316]'}`;
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-xl border-b border-gray-200/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2.5 group" data-testid="nav-logo" onClick={closeMobile}>
            <img src={LOGO_URL} alt="Beyond Ball India" className="h-9 w-9 rounded-full object-contain transition-transform group-hover:scale-105" />
            <div className="leading-none">
              <div className="text-base font-bold tracking-tight text-gray-900">Beyond Ball</div>
              <div className="text-[10px] font-semibold tracking-[0.15em] text-[#F97316] uppercase">India</div>
            </div>
          </Link>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-8">
            {NAV_LINKS.map((l) => (
              <Link key={l.to} to={l.to} onClick={closeMobile} className={linkClass(l.to)} data-testid={l.testId}>
                {l.label}
              </Link>
            ))}

            <div className="h-6 w-px bg-gray-200"></div>

            <NavbarAuthDesktop user={user} onLogout={handleLogout} />
          </div>

          {/* Mobile toggle */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden text-gray-700 p-2 -mr-2"
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {mobileOpen ? <X size={24} weight="bold" /> : <List size={24} weight="bold" />}
          </button>
        </div>

        {/* Mobile menu */}
        {mobileOpen && (
          <div className="md:hidden py-4 border-t border-gray-200/60 space-y-3" data-testid="mobile-menu">
            {NAV_LINKS.map((l) => (
              <Link key={l.to} to={l.to} onClick={closeMobile} className="block py-2 text-base font-medium text-gray-700">
                {l.label}
              </Link>
            ))}
            <div className="pt-3 border-t border-gray-200/60 space-y-3">
              <NavbarAuthMobile user={user} onLogout={handleLogout} onClose={closeMobile} />
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
